import CarrierIndex from '../components/carriers/CarrierIndex.vue';
import CarrierDetails from '../components/carriers/CarrierDetails.vue';



export default [

	{
		path: '/carriers',
		name: 'CarrierIndex',
		component: CarrierIndex,
		meta: {
			requiresAuth: true,
			permissions: {
				Carriers: ["*"]
			}
		}
	},
	{
		path: '/carriers/:carrier_id',
		name: 'CarrierDetails',
		component: CarrierDetails,
		meta: {
			requiresAuth: true,
			permissions: {
				Carriers: ["*"]
			}
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/CarrierRoutes.js